import type { TreeNode } from "../TreeSelectMenu"

/**
 * Flattens a tree into a single list containing every node (parents and
 * children alike), depth-first. Used to look up a label by code regardless
 * of its depth.
 */
export const flattenTree = <T extends string>(nodes: TreeNode<T>[]): TreeNode<T>[] =>
  nodes.flatMap(({ children, ...node }) => [node, ...flattenTree(children ?? [])])
